import '../../styles/corp.css';
import React, { useEffect, useState } from 'react';
import HeaderFFF from '../../components/HeaderFFF'
import Header from '../../components/Header'
import Footer from '../../components/Footer';
import { Link } from 'react-router-dom';

export default function Corporate() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);
    
        useEffect(() => {
            const handleResize = () => {
                setIsMobile(window.innerWidth <= 991);
            };
    
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);
    
        return(
            <>
            {isMobile ? <Header /> : <HeaderFFF />}
        <div id="corp">
            <div id="corp-header-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <h2>Corporate & Commercial Law</h2>
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </div>
            <div id="corp-container">
                <img src="/img/fields/corp/main.png" alt="A black chair in front of a white wall."></img>
                <div id="corp-text">
                    <p>Creative ideas, financial resources, and strategic marketing plans are all important components to a successful business. However, the most important component of a business is its legal structure.
                    
                    Building a business without legal structure is like building a house without laying a foundation.  Unfortunately, many entrepreneurs ignore this aspect of business and seek legal counsel only when a problem arises. It is a wise business practice to consult a lawyer before entering into any business transaction. Several business related legal problems can be avoided by seeking legal counsel on various matters.<br/><br></br>
                    Our corporate/commercial department provides comprehensive legal service for the formation, management and operation of business entities. Our clients range from start-ups to established companies. We serve a wide range of industries and are committed to adding value to our clients by working to understand their businesses, missions and strategies and by serving as their strategic business partner.

                    Our experience in lending and factoring transactions enables us to help clients’ structure innovative financing transactions that utilize practical documentation while providing optimum security. The experience we provide not only in documenting new transactions, but also in solving associated non-performing credit problems, makes us effective counsel to lenders. When finance transactions are in a workout or recovery mode, we work closely with our Litigation Group to help clients recoup maximum amounts.
                    </p>
                    Our corporate/commercial department advises corporations, partnerships and individuals in a broad range of matters:
                    <ul>
                    <li>Incorporation, partnerships, joint ventures and other forms of business organizations.</li>
                    <li>Corporate governance issues.</li>
                    <li>Shareholders agreements, non-competition agreements, letters of intent, etc.</li>
                    <li>Negotiation and structuring of business transactions, mergers and acquisitions, divestitures and reorganizations.</li>
                    <li>Business financing and establishment of credit facilities.</li>
                    <li>Domestic and international franchises, licensing arrangements, distributorships and joint ventures.</li>
                    <li>Corporate reorganization and restructuring.</li>
                    <li>Business succession planning and tax planning.</li>
                    </ul>
                </div>
            </div>
            <div className="next-page-double-btn">
                <div className="next-page-btn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="17" viewBox="0 0 13 17" fill="none">
                        <path d="M0.840374 9.59939L10.1851 15.9612C11.3584 16.76 12.8873 15.9263 12.9941 14.4904C13.002 14.3844 12.9831 14.2785 12.9499 14.1776L10.961 8.13557L12.9499 2.09351C12.9831 1.99261 13.002 1.8867 12.9941 1.78077C12.8886 0.364848 11.397 -0.472328 10.2228 0.285009L0.878026 6.31197C-0.276088 7.05633 -0.296349 8.82552 0.840374 9.59939Z" fill="#BF9874"/>
                    </svg>
                    <p><Link to="/fields-of-expertise/real-estate">Real Estate</Link></p>
                </div>
                <div className="next-page-btn">   
                    <p><Link to="/fields-of-expertise/litigation">Litigation</Link></p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="17" viewBox="0 0 13 17" fill="none">
                        <path d="M12.1596 6.33849L2.81487 0.29479C1.64616 -0.461075 0.12465 0.321745 0.00723972 1.67603C-0.00238562 1.78706 0.018628 1.89822 0.0551139 2.00352L2.03901 7.72912L0.055114 13.4547C0.018628 13.56 -0.00238987 13.6712 0.00725817 13.7822C0.123306 15.1176 1.60765 15.9038 2.77722 15.1872L12.122 9.46154C13.2761 8.7544 13.2963 7.07367 12.1596 6.33849Z" fill="#BF9874"/>
                    </svg>
                </div>
            </div>
        </div>
        <Footer/>
        </>
    );
}